import { DASHBOARD_PERIODS, type DashboardPeriod } from "@repo/shared/types";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./period-switch.i18n";

type PeriodSwitchProps = {
  value: DashboardPeriod;
  onChange: (period: DashboardPeriod) => void;
};

/**
 * Month · Quarter · Year · Total, in the widget's top-right corner. Each widget
 * keeps its own period, and a reload starts at Month again — so plain state in
 * the widget, never the URL or storage.
 */
export function PeriodSwitch({ value, onChange }: PeriodSwitchProps) {
  const t = useT(T);
  const labels: Record<DashboardPeriod, string> = {
    month: t.month,
    quarter: t.quarter,
    year: t.year,
    total: t.total,
  };
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as DashboardPeriod)}>
      <TabsList>
        {DASHBOARD_PERIODS.map((period) => (
          <TabsTrigger key={period} value={period}>
            {labels[period]}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
